import { cn } from "$/lib/utils/functions/misc.functions";
import { useState, useRef, type ReactNode } from "react";

interface TooltipProps {
  text: string;
  children: ReactNode;
  className?: string;
}

const AreaGraphWidgetTooltip = ({
  text,
  children,
  className,
}: TooltipProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const tooltipRef = useRef<HTMLDivElement>(null);

  const handleMouseMove = (e: React.MouseEvent) => {
    if (tooltipRef.current) {
      const cursorXPosition = -(
        tooltipRef.current.getBoundingClientRect().left -
        tooltipRef.current.offsetLeft -
        e.clientX
      );
      const cursorYPosition = -(
        tooltipRef.current.getBoundingClientRect().top -
        tooltipRef.current.offsetTop -
        e.clientY
      );

      setPosition({
        x: cursorXPosition + 10,
        y: cursorYPosition + 10,
      });
    }
  };

  return (
    <div
      className={cn(className)}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      onMouseMove={handleMouseMove}
    >
      {children}
      {isVisible && (
        <div
          ref={tooltipRef}
          className="fixed z-50 rounded bg-gray-800 px-2 py-1 text-sm text-white"
          style={{
            position: "absolute",
            left: `${position.x}px`,
            top: `${position.y}px`,
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};

export default AreaGraphWidgetTooltip;
